import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BUTTON_TYPES } from './button-types.enum';
import { constants } from './button.constants';

@Component({
	selector: 'ea-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
	@Input() type: string = constants.buttons.btnPrimaryClass;
	@Input() isSubmit: boolean;
	@Input() isDisabled: boolean;
	@Input() icon: string;
	@Input() size: string;
	@Input() noTransform = false;
	@Input() customClass: string;
	@Input() name: string;
	@Input() title: string;
	@Input() label = '';
	@Input() ariaContext = '';
	@Input() isSubmitting = false;
	@Input() ariaLabel: string;
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() readonly onClick = new EventEmitter<any>();

	btnClass: string;

	ngOnInit(): void {
		if (this.label) {
			this.ariaLabel = `${this.label}${this.ariaContext ? ' ' : ''}${this.ariaContext}`;
		}

		switch (this.type) {
			case BUTTON_TYPES.Primary:
				this.btnClass = constants.buttons.btnPrimaryClass;
				break;
			case BUTTON_TYPES.Secondary:
				this.btnClass = constants.buttons.btnSecondaryClass;
				break;
			case BUTTON_TYPES.Danger:
				this.btnClass = constants.buttons.btnDangerClass;
				break;
			case BUTTON_TYPES.Borderless:
				this.btnClass = constants.buttons.btnBorderlessClass;
				break;
			default:
				this.btnClass = constants.buttons.btnPrimaryClass;
				break;
		}
	}

	handleOnClick($ev): void {
		this.onClick.emit($ev);
	}
}
